

/** Service Type choices for forms and modals wherever this value set is required. */
export const SERVICE_TYPE_DROPDOWN_OPTIONS: { key: string; value: string }[] = [
  { key: 'Service', value: 'Service' },
  { key: 'Install', value: 'Install' },
  { key: 'Replacement/Store Credit', value: 'Replacement/Store Credit' },
  { key: 'Parts Vendor', value: 'Parts Vendor' },
  { key: 'Other', value: 'Other' },
];

export function getServiceTypeDropdownOptionsSorted(): { key: string; value: string }[] {
  return [...SERVICE_TYPE_DROPDOWN_OPTIONS].sort((a, b) => a.key.localeCompare(b.key));
}
